import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { MotiveDataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';
import { Motive } from '../../../../../../shared/types/systemConfiguration/motives';

export const useMotiveData = ({
    data,
    onChangeData,
    onChangeFormik,
}: MotiveDataProps) => {
    const [typePQR, setTypePQR] = useState<ISelect[]>([]);

    const onSubmit = (data: Motive) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(data?.id),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_MOTIVE);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('parent', data?.parent || []);
        formik?.setFieldValue('active', data?.active ?? true);
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_TYPE).then((items) => setTypePQR(items));
    }, []);

    return {
        formik,
        typePQR,
    };
};
